import { type HttpErrorResponse } from '@angular/common/http';
import { type ClientUser } from '@models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ClientUsersActions = createActionGroup({
  events: {
    'Add Client User': props<{ clientId: string; newUserData: ClientUser; }>(),
    'Assign Notification Template': props<{ clientUsers: ClientUser[]; templateId: string; }>(),
    'Client User Created': props<{ createdUser: ClientUser; }>(),
    'Client User Error': props<{ error: HttpErrorResponse; }>(),
    'Client Users Loaded': props<{ clientUsersList: ClientUser[]; }>(),
    'Load Client Users': props<{ clientId: string; }>(),
    'Resend User Invitation': props<{ clientUser: ClientUser; }>(),
    'Resend User Invitation Error': emptyProps(),
    'Resend User Invitation Success': emptyProps(),
    'Reset Client Users': emptyProps(),
    'Reset Totp': props<{ clientUser: ClientUser; }>(),
    'Reset Totp Error': emptyProps(),
    'Reset Totp Success': props<{ clientUser: ClientUser; totpGracePeriodEndsAt: string; }>(),
    'Update User Client': props<{ clientUser: Partial<ClientUser>; clientUserId: string; }>(),
    'Update User Client Success': props<{ clientUser: ClientUser; }>(),
  },
  source: 'Client Users',
});
